// src/components/Homepage/SupportSection.jsx
import React from 'react';
import { Box, Container, Typography, Paper, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Donate from '../QuickLinks/Donate';
import RobertsHome from '../QuickLinks/RobertsHome';

export default function SupportSection() {
    return (
        <Box component="section" sx={{ backgroundColor: 'common.white', py: { xs: 6, md: 8 } }}>
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: 'stretch',
                        gap: { xs: 3, sm: 4 },
                    }}
                >
                    {/* Left: Donate */}
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: { xs: 2, sm: 2.5 } }}>
                        <Donate />
                        <Paper
                            elevation={0}
                            sx={{
                                p: { xs: 2, sm: 3 },
                                borderRadius: 2,
                                bgcolor: 'grey.50',
                                border: '1px solid',
                                borderColor: 'grey.200',
                            }}
                        >
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
                                Have an artifact to donate?
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                If you have photographs, maps, yearbooks, uniforms, tools, or other items tied to
                                Piedmont’s history, we’d love to help preserve them for future generations. Bring
                                them by during museum hours or{' '}
                                <Link component={RouterLink} to="/contact">contact us</Link> to talk with a volunteer about donating.
                            </Typography>
                        </Paper>
                    </Box>

                    {/* Right: Roberts Home */}
                    <Box sx={{ flex: 1 }}>
                        <RobertsHome />
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}
